import { z } from 'zod';

const TimeOfDay = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'Formato HH:MM');

/** [start, end) local times. end <= start means the interval crosses midnight. */
export const ScheduleIntervalSchema = z.tuple([TimeOfDay, TimeOfDay]);
export type ScheduleInterval = z.infer<typeof ScheduleIntervalSchema>;

/** ISO weekday keys "1" (Monday) .. "7" (Sunday). Missing/empty = closed. */
export const BusinessScheduleSchema = z.partialRecord(
  z.enum(['1', '2', '3', '4', '5', '6', '7']),
  z.array(ScheduleIntervalSchema).max(4),
);
export type BusinessSchedule = z.infer<typeof BusinessScheduleSchema>;

export const DEFAULT_BUSINESS_SCHEDULE: BusinessSchedule = {
  '1': [['09:00', '18:00']],
  '2': [['09:00', '18:00']],
  '3': [['09:00', '18:00']],
  '4': [['09:00', '18:00']],
  '5': [['09:00', '18:00']],
};

export const MetricPolicySchema = z.object({
  /** Episode boundary: elapsed hours with no qualifying conversational message. */
  episodeInactivityHours: z.number().min(1).max(24 * 30),
  /** Touch burst: max gap between adjacent outbound messages. */
  burstGapMinutes: z.number().min(1).max(240),
  /** A later outbound burst after this much conversation inactivity counts as a follow-up. */
  followUpInactivityHours: z.number().min(0.25).max(24 * 14),
  /** Threshold used to flag slow first responses in reports. */
  slowResponseMinutes: z.number().min(1).max(24 * 60),
});
export type MetricPolicy = z.infer<typeof MetricPolicySchema>;

export const DEFAULT_METRIC_POLICY: MetricPolicy = {
  episodeInactivityHours: 72,
  burstGapMinutes: 5,
  followUpInactivityHours: 4,
  slowResponseMinutes: 60,
};

export const DEFAULT_TIMEZONE = 'America/Mexico_City';
export const DEFAULT_RETENTION_DAYS = 90;

export const HolidaySchema = z.object({
  id: z.string(),
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  name: z.string().min(1).max(120),
});
export type Holiday = z.infer<typeof HolidaySchema>;
